import axios from "axios"

const route = '/physical_progress';

export default {
    namespaced: true,

    state: () => ({
        dialogNewComposition: false
    }),
    getters: {

    },
    mutations: {

    },
    actions: {
        index(context,data){

            let items_per_page = data.itemsPerPage? data.itemsPerPage:15
            let pagination = `?page=${data.page}&items_per_page=${items_per_page}&search=${data.search}`
            return axios.get(`${route}/physical_progress${pagination}`)
        },

        lockConfirm(context,data){
            return axios.post(`${route}/lock_confirm`,data)
        },

        store(context,data){
            return axios.post(`${route}/physical_progress`,data)
        },
        update(context,data){
            return axios.put(`${route}/physical_progress/${data.physical_progress_id}`,data)
        },

        destroy(context,physicalProgress){
            return axios.delete(`${route}/physical_progress/${physicalProgress.id}`)
        },

        saveHHUnitPhisycalProgress(context, physicalProgressItem) {
            return axios.post(route + '/update_hh_unit', physicalProgressItem)
        },


        // CRIAR NOVO PERIODO
        newPeriod(constext, physical_progress ){
            return axios.post(`${route}/new_period`,physical_progress)
        },

        loadDataPhysicalProgress(context,physical_progress_id){
            return axios.get(`${route}/load_physical_progress/${physical_progress_id}`)
        },

        getServices(context,budget_id) {
            return axios.get(`${route}/get_services/${budget_id}`)
        },

        getCostSelect() {
            return axios.get(`${route}/get_cost_select`)
        },
        getCostSelectNotUsed() {
            return axios.get(`${route}/get_cost_select_not_used`)
        },

        exportExcel(constext,physicalProgressId) {
            return axios.get(route + '/export_excel/'+physicalProgressId,{responseType: 'blob'})
        },

        // DETAILS PHYSICAL PROGRESS **descontinuado
        updateCreateSheetPhysicalProgress(context,data){
            return axios.post(`${route}/update_create_sheet/${data.physical_progress_item_id}`,data)
        },

        //atualiza a ultima medicao
        updateMetering(context,data){
            return axios.post(`${route}/update_metering`,data)
        },

        //adiciona um novo local
        addLocalMetering(context,data){
            return axios.post(`${route}/add_local_metering`,data)
        },

        //deleta um local
        deleteLocalMetering(context,data){
            return axios.post(`${route}/delete_local_metering`,data)
        },

        //*decontinuado*
        getLocals(context,data){
            return axios.post(`${route}/get_locals`,data)
        },

        // carrega as medicoes
        getMetering(context,data){
            return axios.post(`${route}/get_meterings`,data)
        },


        loadContractor(context, composition_id ){
            return axios.get(`${route}/get_contractor_available/${composition_id}`)
        },
        // METERING CONTRACT
        updateCreateMeteringContract(context,data){
            return axios.post(`${route}/update_create_metering_contract`,data)
        },



        // getMeteringContract(context,metering_id){
        //     return axios.get(`${route}/get_metering_contract/${metering_id}`)
        // },

        getVerifyAvailableContractor(constext,data){
            return axios.post(`${route}/get_verify_available_contractor` ,data)
        },

        //carrega o serviço associado a composicao
        getService(context, composition){
            return axios.get(`${route}/get_service/${composition.id}`)
        }





    }
}


